import {AnyAction} from 'redux';
import {SAVE_POWER_SOURCE_COUNTS} from '../action';
import {PowerSourceCounts} from '../../reducers/savedPowerSourceCounts';


/**
 * save a snapshot of the current counts of each power source type
 */
export function savePowerSourceCounts(counts: PowerSourceCounts) : AnyAction
{
    return {type: SAVE_POWER_SOURCE_COUNTS, payload: {counts}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/power-sources/savePowerSourceCounts.ts.ts